<template>
  <div class="use-list">
    <div v-for="(item, index) in useInfo" :key="index">{{ item }}</div>
  </div>
</template>

<script>

export default {
  props: {
    useInfo: Array,
  },
};
</script>
<style lang="scss" scope>

</style>



// WEBPACK FOOTER //
// src/views/tools/component/UseInfoText.vue